export enum ShapeTypes {
    Waves = 1,
    WavesOpacity = 2,
    // Tilt = 3,
    // Triangle = 4,
    // TriangleAsymmetrical = 5,
    // Curve = 6,
    // CurveAsymmetrical = 7,
}
